<template>
  <div class="status-box">
    <!-- 待支付 -->
    <template>
      <div class="status-title">支付方式</div>
      <div class="img-box qr-box">
        <!-- <img src="../../assets/images/weixin-qr.png" alt="" /> -->
        <vue-qr
          :text="code_url"
          :size="200"
          :margin="10"
          colorDark="#000"
          colorLight="#fff"
          :logoScale="0.2"
        ></vue-qr>
        <!-- :logoSrc="logoPath" -->
        <p class="qr-tip is-small">用微信扫一扫即可付款</p>
      </div>
      <div class="pay-container">
        <div class="layui-row row-flex layui-col-space20">
          <div class="layui-col-sm7 layui-col-xs12">
            <div class="text-box">
              <div class="title">参赛费用与说明</div>
              <p class="is-small">费用标准：80元/人</p>
              <p class="is-small">报名福利：缴费成功即赠公会定制专属大赛礼包</p>
              <p class="is-small">费用用途：专专项用于赛事组织、物料制作、专家评审等相关支出；</p>
              <p class="is-small">退费规则：缴费成功即视为确认参赛，若因个人原因无法参赛，报名费不予退还。</p>
            </div>
          </div>
          <div class="layui-col-sm5 layui-col-xs12">
            <img src="../../assets/images/lb1.png" alt="" style="width: 260px !important;float: right;">
          </div>
        </div>
      </div>
      <div class="ala-tip color_primary" style="">*注：支付成功概不退费</div>
    </template>
    <!-- 支付成功 -->
    <!-- <template>
      <div class="status-title">支付成功</div>
      <img src="../../assets/images/success.png" width="240" alt="">
      <p class="color_primary"><strong>支付成功，发货时间待定</strong></p>
      <div class="team-button-box">
          <el-button class="pre">下一步</el-button>
      </div>
    </template> -->
  </div>

</template>

<script>
import { apiGetPayLink, apiGetPayStatus, apiSetProcess } from '../../plugins/apis';
import vueQr from 'vue-qr';

export default {
  // 组件参数 接收来自父组件的数据
  props:['round','label'],
  // 局部注册的组件
  components: {
    vueQr
  },
  // 组件状态值
  data() {
    return {
      timer: null,
      code_url: '', // 支付链接
      order_sn: '', // 订单号
    }
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    // 查询支付状态
    async checkPaymentStatus() {
      const res = await apiGetPayStatus(this.order_sn);
      if (res.code === 200 ) {
        if(res.data.pay_status === 1) {
          clearInterval(this.timer);
          await apiSetProcess(this.round.round_id,this.label)
          this.$Bus.$emit("reload_NowProcess")
        }
      }
    },

    // 获取支付链接
    async getPaymentLink() {
      const res = await apiGetPayLink();
      if (res.code === 200) {
        this.code_url = res.data.code_url;
        this.order_sn = res.data.order_sn;
      }
    }
  },
  async mounted() {
    await this.getPaymentLink()
    this.timer = setInterval(() => {
      this.checkPaymentStatus();
    }, 2000);
  },
}
</script>

<style scoped></style>
